
export const text = `[ID: A photo of a man with short, disheveled gray hair. He appears to be in his late-twenties. It appears to be night-time, as he is asleep on the bottom part of a bunk bed. There is a stuffed animal depicting a dinosaur with a party hat. He is clinging to it as he drifts off.]



`